<template lang="pug">
  v-app
    app-toolbar(v-if="IS_USER_LOGGED_IN" @loading="onLoadingChange" @toolsSuccessSnackbar="onToolsSuccessSnackbar" @toolsErrorSnackbar="onToolsErrorSnackbar")
    app-drawer(v-if="IS_USER_LOGGED_IN")
    EmployeeMessagesDialog(v-if="show" :show="show" :messageList="messageList" @close="show=false")
    ProgressCircular(:loading="loading")
    v-snackbar(v-model="showSnackbar" :timeout="3000" :color="snackbarColor ? 'success' : 'error'")
      span(v-html="messageSnackbar")
      template(v-slot:action="{ attrs }")
        v-btn(dark text @click="showSnackbar = false" v-bind="attrs") {{ $t('close') }}

    v-main
      v-container.app-container.fill-height.pa-0(fluid)
        router-view
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { IS_USER_LOGGED_IN } from './store/getter-types'
import AppToolbar from './components/AppToolbar.vue'
import AppDrawer from './components/AppDrawer.vue'
import "@bryntum/scheduler/scheduler.stockholm.css";
import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css'
import { GET_USER_MESSAGES } from '@/store/getter-types'
import EmployeeMessagesDialog from '@/components/EmployeeMessagesDialog'
import ProgressCircular from '@/components/ProgressCircular'
import { SnackbarStateEnum } from '@/types/enums'

export default Vue.extend({
  name: 'App',

  components: {
    AppToolbar,
    AppDrawer,
    EmployeeMessagesDialog,
    ProgressCircular
  },

  watch: {
    GET_USER_MESSAGES (newVal) {
      this.messageList = newVal
      if(this.messageList.length > 0) {
        this.show = true
      }
    }
  },

  computed: {
    ...mapGetters([
      IS_USER_LOGGED_IN,
      GET_USER_MESSAGES
    ]),

    snackbarColor () {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  data () {
    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      show: false,
      messageList: []
    }
  },

  methods: {
    onLoadingChange (loading) {
      this.loading = loading
    },

    onToolsSuccessSnackbar () {
      this.messageSnackbar = 'Der Versand wurde ausgeführt.'
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true
    },

    onToolsErrorSnackbar () {
      this.messageSnackbar = this.$t('errors.functionCouldNotBeExecuted')
      this.snackbarState = SnackbarStateEnum.Error
      this.showSnackbar = true
    }
  },

  async created () {
    if(localStorage.getItem('primaryColor') && localStorage.getItem('secondaryColor')) {
      this.$vuetify.theme.themes.light.primary = localStorage.getItem('primaryColor')
      this.$vuetify.theme.themes.light.secondary = localStorage.getItem('secondaryColor')
    }
    document.documentElement.style.setProperty('--primary', localStorage.getItem('primaryColor').toString())
    document.documentElement.style.setProperty('--secondary', localStorage.getItem('secondaryColor').toString())
  }
})
</script>

<style lang="stylus">
  .theme--light.v-btn.v-btn--disabled, .theme--light.v-btn.v-btn--disabled .v-btn__loading, .theme--light.v-btn.v-btn--disabled .v-icon
    color var(--secondary) !important
    opacity 0.54 !important

  .theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step
    background-color  var(--secondary) !important
    opacity 0.38 !important

  .app-container
    background-color #fafafa
</style>
